import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Grid, Icon, Typography } from 'gu-ui-kit'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import LanguageSelector from 'components/Footer/subcomponents/LanguageSelector'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { APP_PRODUCT_PUBLIC_NAME } from 'constants/app-config'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'
import styles from 'components/Footer/footer.module.scss'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

const Footer = ({ wide = false }) => {
  const pathGen = useGeneratePathI18n()
  const breakpoints = useBreakpoint()
  const { t } = useTranslation(['common'])

  return (
    <Grid
      alignItems={'center'}
      justifyContent={'between'}
      className={styles['footer']}
      fluid={false}
      wrap={false}
      direction={breakpoints.fb ? 'row' : 'column'}
      gap={24}
    >
      <Grid
        alignItems={wide && breakpoints.fb ? 'start' : 'center'}
        justifyContent={wide ? 'start' : 'space-between'}
        gap={breakpoints.xl && !wide ? 24 : 16}
        wrap={!breakpoints.xl}
        fluid={false}
        direction={wide && breakpoints.fb ? 'column' : 'row'}
      >
        <Grid
          direction={'row'}
          wrap={false}
          fluid={false}
          gap={4}
        >
          <Typography
            noWrap
            color={'Label-Secondary'}
            variant={'Body-15'}
          >
            {new Date().getFullYear()} ©
          </Typography>
          <Typography
            noWrap
            color={'Label-Secondary'}
            component={Link}
            to={pathGen(ROUTES.MAIN)}
            variant={'Body-15'}
          >
            {APP_PRODUCT_PUBLIC_NAME}
          </Typography>
        </Grid>

        {IS_APP_PRODUCT_GETUNIQ && (
          <Grid
            fluid={false}
            wrap={'nowrap'}
            gap={16}
          >
            <Button
              target={'_blank'}
              component={'a'}
              href={'https://t.me/getuniq'}
              variant={'ghost'}
              noLabel
              size={'s'}
              startIcon={<Icon name={'socials-telegram'} />}
            />

            <Button
              target={'_blank'}
              component={'a'}
              variant={'ghost'}
              href={'https://vk.ru/getuniqme'}
              noLabel
              size={'s'}
              startIcon={<Icon name={'socials-vk'} />}
            />

            <Button
              target={'_blank'}
              component={'a'}
              variant={'ghost'}
              href={'https://youtube.com/@getuniq7721?si=EkeHqudwrg8e_IqY'}
              noLabel
              size={'s'}
              startIcon={<Icon name={'socials-youtube'} />}
            />
          </Grid>
        )}
      </Grid>

      <Grid
        as={'nav'}
        justifyContent={'center'}
        gap={16}
        fluid={false}
      >
        <Typography
          variant={'Body-15'}
          color={'Label-Secondary'}
          component={'a'}
          href={pathGen(ROUTES.OFERTA)}
        >
          {t('footer.user_agreement')}
        </Typography>
        <Typography
          variant={'Body-15'}
          color={'Label-Secondary'}
          component={'a'}
          href={pathGen(ROUTES.PRIVACY_POLICY)}
        >
          {t('footer.privacy_policy')}
        </Typography>
        <Typography
          variant={'Body-15'}
          color={'Label-Secondary'}
          component={'a'}
          href={pathGen(ROUTES.CONTACTS)}
        >
          {t('footer.contacts')}
        </Typography>
        <Typography
          variant={'Body-15'}
          color={'Label-Secondary'}
          component={'a'}
          href={pathGen(ROUTES.FAQ)}
        >
          {t('footer.help')}
        </Typography>

        {IS_APP_PRODUCT_GETUNIQ && (
          <Typography
            variant={'Body-15'}
            color={'Label-Secondary'}
            component={'a'}
            href={`${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_DOMAIN}${ROUTES.BLOG_URL}`}
            rel="noreferrer"
            target="_blank"
          >
            {t('footer.blog')}
          </Typography>
        )}
      </Grid>

      <Grid
        wrap={false}
        fluid={false}
        justifyContent={'between'}
        gap={!breakpoints.md ? 24 : 8}
        direction={!breakpoints.fb && breakpoints.md ? 'column' : 'row'}
      >
        <LanguageSelector />
      </Grid>
    </Grid>
  )
}

export default Footer

Footer.propTypes = {
  wide: PropTypes.bool,
}
